import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { HttpService } from '../../http.service';
import { ActivatedRoute } from '@angular/router';
import { TableComponent } from '../table/table.component';
@Component({
  selector: 'app-bank-report',
  templateUrl: './bank-report.component.html',
  styleUrls: ['./bank-report.component.scss']
})
export class BankReportComponent implements AfterViewInit {

  public today: any = new Date();
  public date = this.today.getFullYear() + "-" + ("0" + (this.today.getMonth() + 1)).slice(-2) + "-" + ("0" + this.today.getDate()).slice(-2);

  private bank_uuid: any;
  private is_init: boolean = false;
  @ViewChild("history", { static: false }) wl: TableComponent;

  constructor(private activedRoute: ActivatedRoute) {
    this.today = this.today.getFullYear() + "-" + ("0" + (this.today.getMonth() + 1)).slice(-2) + "-" + ("0" + this.today.getDate()).slice(-2);

    this.activedRoute.params.subscribe((v) => {
      this.bank_uuid = v.bank_uuid;
      this.init();
    })
    this.activedRoute.queryParams.subscribe((v) => {
      if (v.date) {
        this.date = v.date;
      }
      this.init();
    })
  }

  ngAfterViewInit(): void {
    this.is_init = true;
    this.init();
  }


  inputchange() {
    this.init();
  }

  async init() {
    if (!this.is_init) {
      return;
    }

    const playerSummary =
    {
      post: { url: "/admin/company/bank/summary", data: { date: this.date, bank: this.bank_uuid } },
      disabled_pagenat: false,
      show_sum: true,
      fields: [
        { label: 'No', type: 'index' },
        { label: 'Bank', type: 'string', key: 'bank' },
        { label: 'Admin', type: 'string', key: 'admin' },
        { label: 'Player', type: 'string', key: 'player' },
        { label: 'Debit/In', type: 'price', key: 'debit', sum: true, border_left: true, border_right: true },
        { label: 'Credit/Out', type: 'price', key: 'credit', sum: true, border_left: true, border_right: true },
        { label: 'Balance', type: 'price', key: 'balance', sum: true, border_left: true, border_right: true },
        { label: 'Profit', type: 'price', key: 'profit', sum: true, border_left: true, border_right: true },
        { label: 'Create On', type: 'timestamp', key: 'create_on' }
      ]
    }
    this.wl.init(playerSummary);
  }
}
